import React, { Component } from 'react';

import SocialLogin from 'react-social-login';
import PropTypes from 'prop-types';


class Button extends Component {
    static propTypes = {
        triggerLogin: PropTypes.func.isRequired,
        triggerLogout: PropTypes.func.isRequired
    }


    render() {
        const { children, triggerLogin, triggerLogout, ...props } = this.props
        return (
            <div onClick={triggerLogin} {...props}>
                {children}
            </div>
        )
    }
}

export default SocialLogin(Button);


// WEBPACK FOOTER //
// ./src/components/Login/SocialButton.js